import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

const LayoutProvider = props => {
  const { children } = props;

  return (
    <Stack minHeight="100vh" minWidth="100%" width="fit-content">
      <Box py={5} px={2} alignItems="center" justifyContent="center">
        {children}
      </Box>
    </Stack>
  );
};

export default LayoutProvider;
